import { useQuery } from "@tanstack/react-query";
import { getUser } from "./";
import { useSelector } from "react-redux";
import { selectUser } from "store/user/selectors";

export default function useUser(props) {
  const user = useSelector(selectUser);

  const queryData = useQuery({
    queryKey: ["user"],
    queryFn: getUser,
    select: ({ data }) => data,
    enabled: Boolean(user?.id),
  });

  return queryData;
}
